import React from 'react';

import { Login, LoginForm, useTranslate } from 'react-admin';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getZ3PConfigValue } from './helper';

const useStyles = makeStyles(
  () => ({
    backButton: {
      width: '100%',
      textAlign: 'center',
      fontSize: '0.75rem',
      marginTop: '2px',
      marginBottom: '8px',
    },
  }),
  { name: 'RaLoginForm' },
);

// https://github.com/marmelab/react-admin/blob/15c8306dedaaea5f79372a19727ec7c3886f22de/docs/Theming.md#using-a-custom-login-page
const MyLoginPage = (props) => {
  const logo = getZ3PConfigValue('logo');
  const customer_facing_name = getZ3PConfigValue('customer_facing_name');
  const classes = useStyles(props);
  const translate = useTranslate();

  return (
    <Login>
      <div style={{ textAlign: 'center', padding: 20 }}>
        {logo ? (
          <img
            src={logo}
            alt={customer_facing_name}
            style={{ maxHeight: 120, maxWidth: 300 }}
          />
        ) : (
          <div style={{ maxWidth: 300 }}>
            <Typography variant="h4">{customer_facing_name}</Typography>
          </div>
        )}
      </div>

      <LoginForm />
      <div className={classes.backButton}>
        <a style={{ color: 'gray' }} href="/#/forgot-password">
          {translate('auth.forgot_password')}
        </a>
      </div>
      <div className={classes.backButton}>
        <a style={{ color: 'gray' }} target="_blank" href="/#/privacy-policy">
          {translate('auth.privacy_policy')}
        </a>
      </div>
    </Login>
  );
};

export default MyLoginPage;
